import React, { Component, createContext, useContext } from 'react'
import { local } from 'utilities/storage'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import constants from 'constants'

const ThemeContext = createContext()
ThemeContext.displayName = 'Theme'

export default class ThemeProvider extends Component {
    constructor(props) {
        super(props)

        const name = local.get('theme')

        this.state = {
            name,
            userPreferredName: getThemeNameFromUserPreference(),
            setTheme: this.set,
            supportsAnchorPositioning: ('anchorName' in document.documentElement.style),
            activeClickPopovers: new Set()
        }

        this.colorSchemeQuery = global.matchMedia?.('(prefers-color-scheme: dark)')
    }

    componentDidMount() {
        this.set(this.state.name)

        this.colorSchemeQuery?.addEventListener('change', this.handleColorSchemeChange)
    }

    componentWillUnmount() {
        this.colorSchemeQuery?.removeEventListener('change', this.handleColorSchemeChange)
    }

    set = name => {
        if(!['system', 'light', 'dark'].includes(name)) {
            return
        }

        const html = document.documentElement
        const colorSchemeMeta = document.querySelector('meta[name="color-scheme"]')

        html.dataset.theme = name

        if(name === 'system') {
            colorSchemeMeta.content = this.state.userPreferredName
        } else {
            colorSchemeMeta.content = name
        }

        this.setState({ name }, this.store)
    }

    handleColorSchemeChange = event => {
        const newPreferredName = event.matches ? 'dark' : 'light'

        this.setState({ userPreferredName: newPreferredName }, () => {
            if(this.state.name === 'system') {
                const colorSchemeMeta = document.querySelector('meta[name="color-scheme"]')
                colorSchemeMeta.content = newPreferredName
            }
        })
    }

    store = () => local.set('theme', this.state.name)

    render() {
        const { children = null } = this.props

        return (
            <ThemeContext.Provider value={this.state}>
                <StyledThemeProvider theme={constants}>
                    {(typeof children === 'function') && children(this.state)}
                    {(typeof children !== 'function') && children}
                </StyledThemeProvider>
            </ThemeContext.Provider>
        )
    }
}

const getThemeNameFromUserPreference = () => {
    return global.matchMedia?.('(prefers-color-scheme: dark)').matches ?
        'dark' :
        'light'
}

export const useTheme = () => useContext(ThemeContext)